export default {
  title: 'Steuerliche Details',
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    success: 'Deine Informationen wurden erfolgreich gespeichert.',
  },
};
